import { useEffect, useRef, useState } from "react";
import { desktopWidth } from "../../assets/styles/variables";

type UsePreviousReturn<T> = T | undefined;
export const usePrevious = <T>(value: T): UsePreviousReturn<T> => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  // eslint-disable-next-line react-hooks/refs
  return ref.current;
};

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(
    window.innerWidth >= desktopWidth
  );

  const checkIsDesktop = (): void => {
    setIsDesktop(window.innerWidth >= desktopWidth);
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    checkIsDesktop();

    const mediaQuery = window.matchMedia(`(min-width: ${desktopWidth}px)`);

    const handleResize = (event: MediaQueryList) => {
      setIsDesktop(event.matches);
    };

    mediaQuery.addEventListener(
      "change",
      handleResize as unknown as EventListener
    );

    return () => {
      mediaQuery.removeEventListener(
        "change",
        handleResize as unknown as EventListener
      );
    };
  }, []);

  return isDesktop;
}
